import { ResetCSS } from 'common/assets/css/style';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import { theme } from 'common/theme/app';
import { ContentWrapper, GlobalStyle } from 'containers/App/app.style';
import Footer from 'containers/App/Footer';
import Navbar from 'containers/App/Navbar';
import PropTypes from 'prop-types';
import React from 'react';
import Sticky from 'react-stickynode';
import { ThemeProvider } from 'styled-components';

const SiteLayout = ({ children, showFooter = true }) => (
  <ThemeProvider theme={theme}>
    <ResetCSS />
    <GlobalStyle />
    <ContentWrapper>
      <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
        <DrawerProvider>
          <Navbar />
        </DrawerProvider>
      </Sticky>
      <main>{children}</main>
      {showFooter ? <Footer /> : null}
    </ContentWrapper>
  </ThemeProvider>
);

SiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showFooter: PropTypes.bool,
};

export default SiteLayout;
